angular.module('qkr').controller('PasswordController', ($scope, $http, appConfig, utils, FormHelper, messageService,
                                                        gettextCatalog) => {
    $scope.form = {
        password: {
            current: '', new: '', confirm: ''
        }
    };
    $scope.errors = {};
    let formHelper = new FormHelper($scope),
        pwdRegexp = new RegExp('^.{8,}$', 'i'),
        pwdFormat = gettextCatalog.getString('Password should contain at least 8 characters.');

    let validate = function(currentPwd, newPwd, pwdConfirmation) {
        const errors = {};

        if (utils.hasNoValue(currentPwd))
            errors.currentPassword = gettextCatalog.getString('Please provide the current password.');

        if (utils.hasNoValue(newPwd))
            errors.newPassword = gettextCatalog.getString('Please provide the new password.');

        if (utils.hasNoValue(pwdConfirmation))
            errors.passwordConfirmation = gettextCatalog.getString('Please confirm the new password.');

        if (newPwd && pwdConfirmation && (newPwd != pwdConfirmation))
            errors.passwordConfirmation = gettextCatalog.getString('New password and password confirmation don\'t match.');

        if (!pwdRegexp.test(currentPwd))
            errors.currentPassword = pwdFormat;

        if (!pwdRegexp.test(newPwd))
            errors.newPassword = pwdFormat;

        if (!pwdRegexp.test(pwdConfirmation))
            errors.passwordConfirmation = pwdFormat;

        if (currentPwd === newPwd)
            errors.passwordConfirmation = gettextCatalog.getString('New password can\'t be same as current password.');

        if (!(/\d/.test(newPwd))) {
            errors.newPassword = gettextCatalog.getString('Passwords must include a number');
        }

        if (!(/[A-z]/.test(newPwd))) {
            errors.newPassword = gettextCatalog.getString('Passwords must include a letter');
        }

        if ((/(.)(\1){2,}/.test(newPwd))) {
            errors.newPassword = gettextCatalog.getString('Passwords can\'t contain any character more than 3 time in succession.');
        }

        if (!(/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(newPwd))) {
            errors.newPassword = gettextCatalog.getString('Passwords must include a special character');
        }

        $scope.errors = errors;
        return utils.isEmpty(errors);
    },

    responder = function(response) {
        const r = formHelper.handleResponse(response);

        if (r.isSuccess()) {
            messageService.success(gettextCatalog.getString('Password changed successfully.'));
        } else {
            messageService.errorWithReason(response.data.errors[0].reason, response.data.errors[0].field, true);
        }
    },

    savePassword = function(currentPwd, newPwd, pwdConfirmation) {
        const payload = {currentPassword: currentPwd, newPassword: newPwd, passwordConfirmation: pwdConfirmation};
        return $http.post(appConfig.apiUrl + 'password/update', payload).then(
            (promise) => {
 responder(promise); 
},
            (promise) => {
 responder(promise); 
}
        );
    };

    $scope.changePassword = function() {
        if (validate($scope.form.password.current, $scope.form.password.new, $scope.form.password.confirm)) {
            savePassword($scope.form.password.current, $scope.form.password.new, $scope.form.password.confirm);
        }
    };
});



// WEBPACK FOOTER //
// ./src/controllers/password.controller.js